export default {
  home: 'Home',
  ownersEntry: 'Owners',
  residentsEntry: 'Residents',
  aboutUs: 'About Us',
  contactUs: 'Contact Us',
  slogan: 'It\'s all about your properties',
  subSlogan: 'Professional full-service property management',
};
